import React from 'react';
import { Row } from 'antd';
import { Formik, Form as FormikForm } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './ForgotPasswordForm.module.scss';
import { useNavigate } from 'react-router-dom';
import AuthenticationService from 'services/AuthenticationService/authentication.service';

import {
  Fields,
  initialValues,
  validationSchema,
} from './ForgotPasswordFormConstants';
import { ForgotPasswordProps } from 'enums/ForgotPasswordFormEnums';

interface ForgotPasswordFormProps {
  email: string;
}

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  const { forgotPassword, buttonLoading } = AuthenticationService();
  const handleApiSubmission = async (values: ForgotPasswordFormProps) => {
    forgotPassword({ email: values.email });
  };
  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={ForgotPasswordProps.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{ForgotPasswordProps.HEADING}</h1>
        </div>
        <div>
          <h2>{ForgotPasswordProps.SUBHEADING}</h2>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => handleApiSubmission(values)}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      name={field.name}
                      placeholderstring={field.placeholder}
                      label={field.label}
                    />
                  </div>
                );
              })}

              <div className={styles.buttonContainer}>
                <COButton
                  submit
                  loading={buttonLoading}
                  disabled={!formik.isValid}>
                  {ForgotPasswordProps.BUTTON_LABEL_SUBMIT}
                </COButton>
                <COButton secondary onClick={handleGoBack}>
                  {ForgotPasswordProps.BUTTON_LABEL_BACK}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
